Ext.define('SA.AbstractPredicate', {
    isNullPredicate() {
        return this.hasNullType === true;
    }
});